import { defineComponent, reactive, watch } from '@vue/composition-api'
import './index.scss'
import { INPUT_VALUE_TYPE_RULE } from '../../config'
import _ from 'lodash'
import VueI18n from 'vue-i18n'
import i18n from '@/locales'
const FillContent = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    i18n: {
      type: VueI18n
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item), //编辑数据源
      errorText: ''
    })

    watch(
      () => props.item,
      (val) => {
        state.editItem = _.cloneDeep(val)
      },
      {
        deep: true
      }
    )

    const blurInput = (value, sitem) => {
      let svalue = value.target.value?.toString()?.trim()
      //如果没有勾选非必填时,需要做内容的空判断
      if (!state.editItem.topicSetting.isAllowNull) {
        if (!svalue) {
          state.editItem.inputErrorTips = props.i18n?.t('survy.plccontent')
          state.editItem.isShowInputError = true
          emit('answer', state.editItem)
          return
        }
      }
      //字符类型
      let format = sitem.topicSetting.format
      if (format) {
        let reg = INPUT_VALUE_TYPE_RULE[format].reg
        let name = INPUT_VALUE_TYPE_RULE[format].name
        if (!reg.test(svalue)) {
          let errtips =
            `${props.i18n?.t('common.enterPlaceholder')}` +
            props.i18n?.t(`survy.${format}`)
          if (format === 'phone') {
            errtips = props.i18n?.t(`survy.phoneFormat`)
          }
          if (format === 'email') {
            errtips = props.i18n?.t(`survy.emailFormat`)
          }
          state.editItem.inputErrorTips = errtips
          state.editItem.isShowInputError = true
          emit('answer', state.editItem)
          return
        }
      }
      state.editItem.inputErrorTips = ''
      state.editItem.isShowInputError = false
      emit('answer', state.editItem)
    }

    const elInputChange = (value) => {
      state.editItem.value = value
      //看是否做了字符长度限制
      if (state.editItem.topicSetting.textLessThan) {
        state.editItem.value = value.slice(
          0,
          state.editItem.topicSetting.textLessThan
        )
      }
      state.editItem.inputErrorTips = ''
      state.editItem.isShowTitleError = false
      emit('answer', state.editItem)
    }

    return () => {
      return (
        <div class="fill-topic-content">
          <el-input
            onInput={(value) => elInputChange(value)}
            onblur={(value) => blurInput(value, state.editItem)}
            value={state.editItem.value}
            size="medium"
            placeholder={props.i18n?.t('survy.plccontent')}>
            {state.editItem.topicSetting.format === 'phone' && (
              <template slot="prefix" class="phone-icon-prefix">
                <div class="phone-icon"></div>
              </template>
            )}
            {state.editItem.topicSetting.format === 'email' && (
              <template slot="prefix" class="email-icon-prefix">
                <div class="email-icon"></div>
              </template>
            )}
          </el-input>
          {state.editItem.isShowInputError && (
            <span class="el-input-format-error">
              {state.editItem.inputErrorTips}
            </span>
          )}
        </div>
      )
    }
  }
})

export default FillContent
